import Vuex from 'vuex'
import Vue from 'vue'
import VueFire from 'vuefire'
import Firebase from 'firebase'
import _ from 'lodash'

// explicit installation required in module environments
Vue.use(VueFire)
Vue.use(Vuex)

let config = {
  live: {
    apiKey: 'AIzaSyCuh-K6gBH2EQk9yJzbc_m1sykrL1S1k-4',
    authDomain: 'beerwithme-666.firebaseapp.com',
    databaseURL: 'https://beerwithme-666.firebaseio.com',
    projectId: 'beerwithme-666',
    storageBucket: '',
    messagingSenderId: '884782533433'
  },
  dev: {
    apiKey: 'AIzaSyA-0Kb2UG-CPWQYySqSUuu0hEilRPALOmc',
    authDomain: 'brate-770ce.firebaseapp.com',
    databaseURL: 'https://brate-770ce.firebaseio.com',
    storageBucket: 'brate-770ce.appspot.com',
    messagingSenderId: '154313240111'
  }
}

let activeConfig = config.live

// if (window.location.host.indexOf('kodamera.se') !== -1) {
//   activeConfig = config.live
// }

Firebase.initializeApp(activeConfig)
let db = Firebase.database()

let store = new Vuex.Store({
  state: {
    rateBeers: '',
    raterName: '',
    data: '',
    dateKey: '',
    raters: [],
    beersTested: 0,
    breweriesCount: 0,
    beerTastings: 0,
    uniqueBreweries: []
  },
  getters: {
    rateBeers: state => {
      return state.rateBeers
    },
    raterName: state => {
      return state.raterName
    },
    data: state => {
      return state.data
    },
    dateKey: state => {
      return state.dateKey
    },
    raters: state => {
      return getUniqueRaters(state.data)
    },
    numbersOfBeersTested: state => {
      return state.beersTested
    },
    breweriesCount: state => {
      return state.breweriesCount
    },
    beerTastings: state => {
      return state.beerTastings
    }
  },
  mutations: {
    createBasicData (state, data) {
      state.beerTastings = Object.keys(data).length
      state.beersTested = countNumbersOfBeers(data)

      let breweries = filterUniqueBreweries(data)
      state.breweriesCount = breweries.length
      state.uniqueBreweries = breweries
    },
    setRatingList (state, beersData) {
      let sessions = beersData
      let dates = []
      let beers = []

      for (let key in sessions) {
        dates.push(key)
      }

      // Sort so we have latest first
      dates.sort(function (a, b) { return b - a })

      // Set dateKey so we can use it to push data to firebase
      state.dateKey = dates[0]

      // Extract beer names into beers list
      for (let beer in sessions[dates[0]]) {
        let name = sessions[dates[0]][beer].name
        let ratings = sessions[dates[0]][beer].ratings
        let average = []

        // Get the ratings out to an array
        _.find(ratings, function (obj) {
          average.push(obj.rating)
        })

        // Calculate average and set to NaN if no ratings available
        average = calculateAverage(average)
        beers.push({
          id: beer,
          name: name,
          average: average
        })
      }

      state.rateBeers = beers
    },
    updateRaterName (state, name) {
      state.raterName = name
    },
    setData (state, data) {
      state.data = reorderData(data)
    },
    updateDateKey (state, dateKey) {
      state.dateKey = dateKey
    }
  },
  actions: {
    loadData ({ commit }) {
      let dataRef = db.ref('data')
      dataRef.on('value', data => {
        let data3ol3 = data.val()

        const sortedData = {}
        Object.keys(data3ol3).sort(function (a, b) {
          return b - a
        }).forEach(function (key) {
          sortedData[key] = data3ol3[key]
        })

        commit('setData', sortedData)
        commit('createBasicData', sortedData)
      })
    },
    loadRatingList ({ commit }) {
      let dataRef = db.ref('data')
      dataRef.limitToLast(1).on('value', data => {
        commit('setRatingList', data.val())
      })
    },
    addRating ({ commit }, rateData) {
      let path = rateData.dateKey + '/' +
      rateData.beer +
      '/ratings/' +
      rateData.name

      let dataRef = db.ref('data/' + path)
      dataRef.set({name: rateData.name, rating: rateData.rating})
    },
    setRaterName ({ commit }, name) {
      commit('updateRaterName', name)
    },
    setDateKey ({ commit }, dateKey) {
      commit('updateDateKey', dateKey)
    },
    createNewData ({ commit }, newBeerData) {
      let dateKey = Date.parse(newBeerData.date)
      dateKey = dateKey.valueOf()

      let path = dateKey + '/' + newBeerData.id

      let dataRef = db.ref('data/' + path)
      dataRef.set(newBeerData)
    }
  }
})

function calculateAverage (average) {
  // If average has no value at least we return 0
  let sum = 0

  if (average.length) {
    sum = (_.sum(average) / average.length).toFixed(2)
  }

  return sum
}

function reorderData (data) {
  let beers = []
  // each date
  _.forOwn(data, function (val1, key1) {
    // each beer
    _.forOwn(data[key1], function (beer, key2) {
      let average = []
      let raters = []

      _.find(beer['ratings'], function (obj) {
        average.push(obj.rating)
        raters.push(obj.name.toLowerCase())
      })

      beer.average = calculateAverage(average)
      beer.raters = raters
      beers.push(beer)
    })
  })

  return beers
}
const uniqueArray = arr => [...new Set(arr)]

function getUniqueRaters (data) {
  let raters = []

  for (let i = 0; i < data.length; i++) {
    const element = data[i]

    // If a beer has no ratings it should not be added
    if (element.ratings !== undefined) {
      let users = Object.keys(element.ratings)
      users.forEach(user => {
        raters.push(user)
      })
    }
  }
  raters = uniqueArray(raters)
  raters = _.sortBy(raters, function (el) { return el[0] })

  return raters
}

function countNumbersOfBeers (data) {
  let count = 0
  _.forEach(data, function (value, key) {
    count += Object.keys(value).length
  })

  return count
}

function filterUniqueBreweries (data) {
  let breweries = []

  // Collect all breweries
  _.forEach(data, function (beer, key) {
    _.forEach(beer, function (value, key) {
      breweries.push(value.brewery)
    })
  })

  // Remove duplicates
  breweries = uniqueArray(breweries)

  return breweries
}
export default store



// WEBPACK FOOTER //
// ./src/store.js